import type { TeamRoundHeaderProps } from '@/components/GolfScorecardHeader/GolfScorecardHeader'
import type { Standing } from '@/types/dde/golfLeaderboard.types'
import type { TeamHoleByHoleData } from '@/types/dde/teamHoleByHole.types'
import type { TeamRound } from '@/types/dde/teamRound.types'

export const calculateRoundsInfo = (
  teamData: TeamHoleByHoleData | undefined,
  teamStanding: Standing | undefined
) => {
  if (!teamData || !teamData.roundScores) {
    return { availableRounds: [1], defaultRound: 1, hasPlayoff: false }
  }

  const rounds = Object.keys(teamData.roundScores)
    .map(Number)
    .filter((n) => !Number.isNaN(n))
    .sort((a, b) => a - b)

  const totalRoundsFromLeaderboard = teamStanding
    ? Object.keys(teamStanding.roundInfo || {}).length
    : rounds.length

  const hasPlayoffRound = totalRoundsFromLeaderboard === 5

  const defaultRnd = teamData.currentRound || Math.max(...rounds, 1)

  return {
    availableRounds: rounds.length > 0 ? rounds : [1],
    defaultRound: defaultRnd,
    hasPlayoff: hasPlayoffRound
  }
}

export const findTeamRoundDetail = (
  teamRounds: TeamRound[],
  targetRound: number | string,
  teamStanding: Standing | undefined
): TeamRoundHeaderProps => {
  const detailedLie = teamRounds.find((round) => round.eventElementType === 'DetailedLie')
  const targetRoundNum = typeof targetRound === 'string' ? Number(targetRound) : targetRound

  if (detailedLie) {
    return {
      ...detailedLie,
      roundNo: detailedLie.roundNo || targetRoundNum
    }
  }

  return {
    roundNo: targetRoundNum,
    teamNo: teamStanding?.teamNo || 0,
    strokeNo: -1,
    playerId: teamStanding?.players[0]?.id || 0,
    player: {
      displayName: teamStanding?.players[0]?.displayName || '-',
      country: teamStanding?.players[0]?.country || '-'
    },
    holeNo: -1,
    ballLie: { distanceToPin: -1, surfaceType: '-' }
  }
}
